<div class="insurance-check-alert" fxLayout="row" fxLayoutAlign="space-between">
  <div fxFlexAlign="center">「健康保険証」もしくは「公費受給者証」の確認が必要です</div>
  <button mat-stroked-button class="button-to-patient-detail" [disabled]="!patientInfo" (click)="gotoPatientDetail()">
    患者詳細画面へ
  </button>
</div>
